import ENV from "app/utils/ENV";
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import offlineQueue from "app/utils/offlineQueue";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import alertActions from "app/utils/alertActions";
import prefActions from "app/utils/prefActions";
import momentActions from "app/utils/momentActions";
import chapterActions from "app/utils/chapterActions";
import haptics from "app/utils/haptics";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { Platform, Alert, Vibration } from "react-native";

import store from "app/redux/store";
import { index, create, update, add } from "app/actions/values";
import * as momentActs from "app/actions/moments";
import { setLoading, setUpdatedAt } from "app/actions/app";

let valueActions = {
  // async get(id) {
  //   store.dispatch(setLoading(true));
  //   let res = await apiActions.request(`values/${id}`, "GET");
  //   if (!!res?.success) {
  //     store.dispatch(add([res.value]));
  //     store.dispatch(setLoading(false));
  //     return res;
  //   }
  //   store.dispatch(setLoading(false));
  // },
  async get(id, scoping_chapter_id = null, all_sub_moments = false) {
    if (id == "journal") return valueActions.getJournal();
    store.dispatch(setLoading(true));
    let data = { id, scoping_chapter_id, all_sub_moments };
    // let res = await apiActions.request(`values/get_bullet`, "GET", data);
    let res = await apiActions.request(`values/${id}`, "GET", data);
    if (!!res?.success) {
      console.log("res before dispatch", res);
      store.dispatch(
        add([
          res.value,
          ...res.children,
          ...res.parents,
          ...res.notes,
          ...res.referencers,
          ...(res.value.references || []),
        ]),
      );
      store.dispatch(momentActs.add(res.moments));
      // store.dispatch(addOrUpdate([res.value, ...res.children, ...res.parents]));
      // store.dispatch(onlyAdd([res.value, ...res.children, ...res.parents]));
      // store.dispatch(add(res.children));
      store.dispatch(setLoading(false));
      return res;
    }
    store.dispatch(setLoading(false));
  },
  async getRevisions(id) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/${id}/revisions`);
    store.dispatch(setLoading(false));
    if (!!res?.success) {
      store.dispatch(add(res.values));
      return res;
    }
  },
  async getJournal() {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/journal`);
    store.dispatch(setLoading(false));
    if (!!res?.success) {
      store.dispatch(add(res.children));
      let journalValue = {
        ...valueHelpers.journalValue,
        child_ids: res.children.map((c) => c.id),
      };
      store.dispatch(add([journalValue]));
      return {
        success: true,
        value: journalValue,
      };
    }
  },
  async getRaw(id) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/get_raw?id=${id}`, "GET");
    if (!!res?.success) {
      store.dispatch(setLoading(false));
      return res;
    }
    store.dispatch(setLoading(false));
  },
  async getFamily(id, params = {}) {
    console.log("1-get family");
    store.dispatch(setLoading(true));
    let data = { id, ...params };
    let res = await apiActions.request("values/family", "GET", data);
    console.log("2-get family res", res);
    if (!!res?.success) {
      console.log("3-get family dispatch values");
      store.dispatch(add(res.values));
      store.dispatch(setLoading(false));
      // store.dispatch(setLoading(false));
      console.log("4-get family done");
      return res;
    } else {
      store.dispatch(setLoading(false));
      // store.dispatch(error(res?.error || "Server cannot be reached"));
    }
  },
  async getParents(id) {
    return valueActions.getFamily(id, { up: 2, down: 0 });
  },
  async getChildren(id) {
    return valueActions.getFamily(id, { up: 0, down: 2 });
  },
  async getSubtasks(id) {
    let res = await apiActions.request("values/subtasks", "GET", { id });
    console.log("subtask res", res);
    if (!!res?.success) {
      store.dispatch(add(res.values));
      return res;
    } else {
      // store.dispatch(setLoading(false));
      // store.dispatch(error(res?.error || "Server cannot be reached"));
    }
  },
  async getGrandParents(ids) {
    // store.dispatch(setLoading(true));
    let res = await apiActions.request("values/grand_parents", "GET", { ids });
    if (!!res?.success) {
      store.dispatch(add(res.values));
      store.dispatch(add(res.descendants));
      // store.dispatch(setLoading(false));
      return res;
    } else {
      // store.dispatch(setLoading(false));
      // store.dispatch(error(res?.error || "Server cannot be reached"));
    }
  },
  async getGrandChildren(ids) {
    // store.dispatch(setLoading(true));
    let res = await apiActions.request("values/grand_children", "GET", { ids });
    if (!!res?.success) {
      store.dispatch(add(res.values));
      store.dispatch(add(res.descendants));
      // store.dispatch(setLoading(false));
      return res;
    } else {
      // store.dispatch(setLoading(false));
      // store.dispatch(error(res?.error || "Server cannot be reached"));
    }
  },
  async indexLite(updatedAt = null) {
    store.dispatch(setLoading(true));

    let data = {};
    if (!!updatedAt) data.updated_at = updatedAt;

    console.log("--------begin index_lite begin");
    let ts = new Date().getTime();
    let res = await apiActions.request("values/index_lite", "GET", data);
    let ts2 = new Date().getTime();
    console.log(`--------begin index_lite complete in ${(ts2 - ts) / 1000}s`);
    let values = res?.values;

    if (!!res?.success) {
      storageActions.saveItem("values", values);
      store.dispatch(index([...values]));
      store.dispatch(setLoading(false));

      let timestamp = res.timestamp;
      storageActions.saveItem("updatedAt", timestamp);
      store.dispatch(setUpdatedAt(res.timestamp));
      let ts3 = new Date().getTime();
      console.log(
        `--------index_lite dispatch in ${(ts3 - ts2) / 1000} more s`,
      );
      // return values
    } else console.warn("error", values);
  },
  async index(ids = [], params = {}) {
    let res = await apiActions.request("values", "GET", { ids, ...params });
    if (res?.success) {
      let values = res.values;
      store.dispatch(add(res.values));
      // storageActions.saveItem("values", values);
      return values;
    } else {
      console.warn("error", res);
      return [];
    }
  },
  async indexFromIds(ids = []) {
    return valueActions.index(ids);
    // store.dispatch(setLoading(true));

    // let data = { ids };
    // let res = await apiActions.request("values/index_from_ids", "POST", data);
    // console.log("res!", res);
    // let values = res?.values;
    // if (!!res?.success) {
    //   store.dispatch(add([res.value, ...res.children]));
    //   // store.dispatch(index([...values]));
    //   store.dispatch(setLoading(false));
    // } else console.warn("error", values);
  },
  // async index(updatedAt = null, includeTimestamp = false) {
  //   console.log("index fetch...");
  //   let timestamp = Date.now();
  //   let data = {};
  //   if (!!updatedAt) data.updated_at = updatedAt;
  //   let res = await apiActions.request("values", "GET", data);
  //   let values = res?.values;
  //   let duration = (Date.now() - timestamp) / 1000;
  //   if (!!values?.length) {
  //     values = valueHelpers.sortByTimeline(values);
  //     values = valueHelpers.applyLevels(values);
  //     // values = valueHelpers.applyColors(values)
  //     storageActions.saveItem("values", values);
  //     let timestamp = res.timestamp;
  //     storageActions.saveItem("updatedAt", timestamp);
  //     if (includeTimestamp) {
  //       return { values, timestamp };
  //     }
  //     return values;
  //   } else console.warn("error", values);
  // },
  async autocompleteValues(query, showMore = 0, looseMatch = false) {
    let params = { query };
    if (!!showMore) {
      params.completed = true;
      if (showMore >= 2) {
        params.revised = true;
      }
    }
    if (looseMatch) {
      params.loose = true;
    }
    // let local = await storageActions.fetchItem("local", ENV.LOCAL);
    // let values = [];
    // if (local) {
    //   if (!allValues) allValues = await storageActions.fetchItem("values", []);
    //   // values = allValues.map(v => ({}))
    //   // console.log(allValues)
    //   values = allValues;
    // } else {
    let values = await apiActions.request(
      `values/autocomplete_values`,
      "GET",
      params,
    );
    // }
    return values;
  },
  async calendarMoments(valueId, startDate, endDate) {
    const fmt = (d) => d.toISOString().slice(0, 10);
    return await apiActions.request(`values/${valueId}/calendar_moments`, "GET", {
      start_date: fmt(startDate),
      end_date: fmt(endDate),
    });
  },
  async toggleParent(value, parent) {
    console.log(value, parent);
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/toggle_parent`,
      "PATCH",
      {
        parent_id: parent.id,
      },
    );
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    return true;
  },
  async addParent(value, parent) {
    console.log(value, parent);
    if (!value?.id || !parent?.id) {
      let { values } = store.getState();
      if (!value.id) value = values.find((v) => v.id == value);
      if (!parent.id) parent = values.find((v) => v.id == parent);
    }
    console.log(value, parent);
    if (value.parent_ids.includes(parent.id)) {
      let confirm = await valueActions.confirm(`Remove parent?`);
      if (confirm) valueActions.removeParent(value, parent);
      return;
    }
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/add_parent`,
      "PATCH",
      {
        parent_id: parent.id,
      },
    );
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    // store.dispatch(update(value));
    return true;
  },
  async addChild(value, child) {
    // if (["string", "number"].includes(typeof value)) value = { id: value };
    // if (["string", "number"].includes(typeof child)) child = { id: child };
    return await valueActions.addParent(child, value); // inverted
  },
  async removeParent(value, parent) {
    console.log(`remove parent ${parent.id} from ${value.id}`);
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/remove_parent`,
      "PATCH",
      { parent_id: parent.id },
    );
    console.log(res);
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    return true;
  },
  async removeChild(value, child) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/remove_child`,
      "PATCH",
      { child_id: child.id },
    );
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    // res.updated_values?.forEach((v) => store.dispatch(update(v)));
    return true;
  },
  async archiveParent(value, parent) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/archive_parent`,
      "PATCH",
      { parent_id: parent.id },
    );
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    return true;
  },
  async archiveChild(value, child) {
    store.dispatch(setLoading(true));
    let res = await apiActions.request(
      `values/${value.id}/archive_child`,
      "PATCH",
      { child_id: child.id },
    );
    store.dispatch(setLoading(false));
    if (!res?.success) return false;
    store.dispatch(add(res.values));
    return true;
  },
  async updateValues(value, values = null) {
    alert("updateValues triggered");
    if (!values) values = await storageActions.fetchItem("values", []);
    if (!!value) {
      let { children, parents, ...localValue } = value;
      values = values.map((v) => (v.id == value.id ? localValue : v));
    }
    // console.log(values)
    values = valueHelpers.sortByTimeline(values, false);
    values = valueHelpers.applyLevels(values);
    // console.log(values)
    await storageActions.saveItem("values", values);
    return values;
  },
  async create(value, chapter_id = null, create_chapter = false) {
    if (store.getState().app?.isOnline === false) {
      const tempId = `temp_${Date.now()}`;
      const createdAt = new Date().toISOString();
      const tempValue = {
        ...value,
        id: tempId,
        parent_ids: value.parent_ids || [],
        child_ids: value.child_ids || [],
        created_at: createdAt,
        pending: true,
      };
      store.dispatch(create(tempValue));
      // send created_at and drop "today" so the server pins the value to
      // the day it was written, not the day the queue finally syncs
      await offlineQueue.enqueue({
        model: "values",
        action: "POST",
        data: {
          value: { ...value, created_at: createdAt },
          chapter_id: chapter_id == "today" ? null : chapter_id,
          create_chapter,
        },
        description: offlineQueue.describe("values", "POST", { value }),
        tempId,
      });
      return tempValue;
    }

    store.dispatch(setLoading(true));
    let res;
    try {
      res = await apiActions.request(`values`, "POST", {
        value,
        chapter_id,
        create_chapter,
      });
    } finally {
      store.dispatch(setLoading(false));
    }
    value = res?.value;
    if (!value || !res?.success) return;
    store.dispatch(create(value));

    // focus new value unless parent is already focused or completed
    // if(!value.completed){
    //   let focusIds = store.getState().preferences.focusIds
    //   if(!focusIds.some(id => value.parent_ids.includes(id))){
    //     await prefActions.addFocus(value.id)
    //   }
    // }

    if (!!value.parent_ids?.length) {
      // values
    }
    if (!!value.child_ids?.length) {
    }

    return value;
  },
  async update(id, val, moment_id = null, clientUpdatedAt = null) {
    store.dispatch(setLoading(true));
    let data = {
      id: val.id,
      moment_id,
      value: val,
    };
    if (!!val.child_ids) {
      data.child_ids = val.child_ids;
    }
    if (clientUpdatedAt) {
      data.client_updated_at = clientUpdatedAt;
    }
    let res = await apiActions.request(`values/${id}`, "PATCH", data);
    store.dispatch(setLoading(false));
    if (res === null) {
      const existing = store.getState().values.find((v) => v.id == id);
      if (existing) store.dispatch(update({ ...existing, ...val }));
      return { success: true, queued: true };
    }
    if (res?.conflict) {
      store.dispatch(update(res.value));
      return { conflict: true, value: res.value };
    }
    if (!res?.success) {
      console.error(res?.error || "something went wrong");
      return false;
    }
    let { value, updated_values } = res;
    if (!value) return false;
    store.dispatch(update(value));
    updated_values?.forEach((v) => store.dispatch(update(v)));
    return value;
  },
  async updateCompletedAt(id, timestamp) {
    store.dispatch(setLoading(true));
    let data = {
      id: val.id,
      timestamp,
    };
    let res = await apiActions.request(
      `values/${id}/update_completed_at`,
      "PATCH",
      data,
    );
    let { value, updated_values } = res;
    store.dispatch(setLoading(false));
    if (!value) return false;
    store.dispatch(update(value));
    updated_values?.forEach((v) => store.dispatch(update(v)));
    return true;
  },
  async complete(
    value,
    timestamp = null,
    prompt = true,
    moment_id = null,
    chapter_id = null,
  ) {
    console.log(value, moment_id);
    let shouldUncomplete = !!value.completed_at;
    let secondAction = "complete_at_last_progress";
    let conf = null;
    let events = [];
    let skipPin = false;
    let completeAtLastProgress = false;
    if (prompt) {
      let secondOption = shouldUncomplete ? null : "revise";
      // conf = await valueActions.confirm(
      //   `${shouldUncomplete ? "un" : ""}complete value`,
      //   secondOption,
      //   "Confirm"
      // );
      if (!shouldUncomplete) events = valueHelpers.getTimeline(value);
      if (!shouldUncomplete && !!events.length) {
        conf = await alertActions.confirm({
          title: `${shouldUncomplete ? "Re-open" : "Complete"} value`,
          // text: "complete",
          options: [
            "Complete",
            "Complete at last progress",
            !!value.archived_at ? "Unarchive" : "Archive",
          ],
        });
      } else {
        secondAction = "quick_revise";
        conf = await alertActions.confirm({
          title: `${shouldUncomplete ? "Re-open" : "Complete"} value`,
          // text: `${shouldUncomplete ? "un" : ""}complete`,
          options: [
            `${shouldUncomplete ? "Re-open" : "Complete"}`,
            "Quick Revise",
          ],
        });
      }
      if (!conf) return;
    }

    if (!shouldUncomplete) {
      let frozen = await valueActions.checkIfFrozen(value);
      if (frozen) return;
    }

    console.log(timestamp);

    if (conf == 2 && secondAction == "quick_revise") {
      // quick revise
      console.log(moment_id, chapter_id);
      // let newValue = await valueActions.quickRevise(value, false);
      let newValue = await valueActions.duplicate(value, chapter_id, false);
      if (!!newValue && !!moment_id && !!chapter_id) {
        await momentActions.delete(moment_id, false);
        // await chapterActions.pinValue(chapter_id, newValue.id);
      }
      return;
    } else if (conf == 2 && !!events.length) {
      // complete at last progress — the client timeline has no moments
      // (mutate doesn't serialize them), so the server resolves the real
      // timestamp; the filtered client guess below is only a fallback
      completeAtLastProgress = true;
      let progressEvents = events.filter(
        (e) => e.category != "creation" && !e.pin,
      );
      timestamp = progressEvents[progressEvents.length - 1]?.timestamp;
      skipPin = true;
    } else if (conf == 3) {
      alert("archive");
      return;
    }
    if (!!timestamp) timestamp = new Date(timestamp);
    else timestamp = new Date();
    console.log(timestamp);

    // let local = await storageActions.fetchItem('local', ENV.LOCAL)
    // if(!local){
    //   timestamp = timestamp.toUTCString()
    // }
    timestamp = timestamp.toISOString();

    if (timestamp == "Invalid Date") {
      alert(`Invalid date`);
      return;
    }

    let completed_at = null;
    let completed = !value.completed;
    if (!value.completed_at) {
      completed_at = timestamp;
    }
    // let is_note = completed ? false : undefined;

    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/${value.id}/complete`, "PATCH", {
      value: { completed_at, completed },
      moment_id,
      skip_pin: skipPin,
      complete_at_last_progress: completeAtLastProgress || undefined,
      // value: { completed_at, completed, is_note },
    });
    console.log(res);
    store.dispatch(setLoading(false));
    if (!res.value) return false;

    store.dispatch(add([res.value]));
    if (!!res.updated_values?.length) store.dispatch(add(res.updated_values));
    // res.updated_values?.forEach((v) => store.dispatch(update(v)));

    // if (confirm == 2) {
    //   value = await valueActions.quickRevise(value.id, false);
    // }

    haptics.vibrate();

    return value;
  },
  async delete(value, prompt = true) {
    if (prompt) {
      let confirm = await valueActions.confirm("Delete value");
      if (!confirm) return;
    }

    let res = await apiActions.request(`values/${value.id}`, "DELETE");
    if (res?.success) {
      // let values = await storageActions.fetchItem('values', [])
      // values.splice(values.findIndex(v => v.id == value.id), 1)
      // storageActions.saveItem('values', values)
      store.dispatch({ type: "values/delete", id: value.id });
      return true;
    }
    return false;
  },
  async duplicate(id, chapter_id, prompt = true) {
    if (prompt) {
      let confirm = await valueActions.confirm(
        "confirm",
        null,
        "Duplicate item?",
      );
      if (!confirm) return;
    }
    let value =
      typeof id == "object"
        ? id
        : store.getState().values.find((v) => v.id == id);
    if (!value) {
      alert("value not found");
      return;
    }
    value = {
      ...value,
      created_at: null,
      completed_at: null,
      archived_at: null,
      progress_at: [],
      // the store's color/icon are resolved (own || inherited) — don't lock
      // an inherited one in as the duplicate's own attribute
      color: value.color == value.inherited_color ? null : value.color,
      icon: value.icon == value.inherited_icon ? null : value.icon,
    };
    let res = await valueActions.create(value, chapter_id);
    return res;
  },
  async quickRevise(id, prompt = true) {
    if (prompt) {
      let confirm = await valueActions.confirm("confirm", null, "Revise item?");
      if (!confirm) return;
    }
    let value =
      typeof id == "object"
        ? id
        : store.getState().values.find((v) => v.id == id);
    if (!value) {
      alert("value not found");
      return;
    }
    // let children = valueHelpers.getChildren({ value });
    // let activeChildren = children.filter(
    //   (v) => !v.completed_at && !v.archived_at,
    // );
    // let parents = valueHelpers.getParents({ value });
    // let activeParents = parents.filter((p) => {
    //   if (p.completed_at) {
    //     let newestR = valueHelpers.getCurrentRevision(p);
    //     if (!!newestR && newestR.id != p.id) {
    //       return newestR;
    //     }
    //   } else return !p.completed_at && !p.archived_at;
    // });

    // let childIds = activeChildren.map((c) => c.id);
    // if (!childIds.length) childIds = value.child_ids;

    // let parentIds = activeParents.map((p) => p.id);
    // if (!parentIds.length) parentIds = value.parent_ids;

    value = {
      ...value,
      // child_ids: childIds,
      // parent_ids: parentIds,
    };
    return await valueActions.revise(value);
  },
  async revise(value, timestamp = new Date()) {
    store.dispatch(setLoading(true));
    let data = {
      timestamp,
      shared_note: value.finalReflections,
      // child_ids: value.child_ids,
      id: value.id,
      achievement: value.achievement,
      value: {
        title: value.title,
        text: value.text,
        // symbol: value.symbol,
        // icon: value.icon,
        // color: value.color,
        // cycle: value.cycle,
        // frequency: value.frequency,
        parent_ids: [...value.parent_ids],
        child_ids: [...value.child_ids],
      },
    };
    let res = await apiActions.request(
      `values/${value.id}/revise`,
      "POST",
      data,
    );
    store.dispatch(setLoading(false));
    if (!res.revision) return;
    store.dispatch(create(res.revision));
    if (res.value) store.dispatch(update(res.value));
    res.updated_values?.forEach((v) => store.dispatch(update(v)));
    prefActions.get();
    return res.revision;
  },
  async progress(
    id,
    timestamp = null,
    prompt = false,
    moment_id = null,
    sort = false,
  ) {
    if (typeof moment_id != "number") moment_id = null;
    let value = store.getState().values.find((v) => v.id == id);
    if (!value) {
      console.error(value, store.getState().values);
      alert("value not found in store");
      return;
    }
    let isRipe = valueHelpers.getRipe(value);
    if (prompt && !isRipe) {
      let confirm = await valueActions.confirm(
        "confirm",
        null,
        "Log progress for this item?",
      );
      if (!confirm) return;
    }
    if (isRipe) {
      let confirm = await alertActions.confirm({
        options: ["Progress", "Complete", "Revise"],
        title: "This item is ripe!",
        subtitle: "What would you like to do with it?",
      });
      if (!confirm) return;
      else if (confirm == 1) {
        // continue
      } else if (confirm == 2) {
        // complete
        return await valueActions.complete(value);
        return;
      } else if (confirm == 3) {
        // revise
        RootNavigation.push("Value", { id: value.id, revising: true });
        return;
      }
    }

    if (!!timestamp) timestamp = new Date(timestamp);
    else timestamp = new Date();
    timestamp = timestamp.toISOString();
    if (timestamp == "Invalid Date") {
      alert(`Invalid date`);
      return false;
    }

    store.dispatch(setLoading(true));
    value = await apiActions.request(`values/${id}/progress`, "POST", {
      timestamp,
      moment_id,
      return_value: true,
      sort,
    });
    console.log("RES:", value);
    store.dispatch(setLoading(false));
    if (!!value) {
      store.dispatch(update(value));
      haptics.success();
      return { success: true, value };
    }
  },
  async deleteProgress(value, timestamp, prompt = true) {
    if (prompt) {
      let confirm = await valueActions.confirm(
        "Delete",
        "",
        `Delete progress?`,
      );
      if (!confirm) return;
    }
    // console.log(timestamp, value)
    if (!value.progress_at?.length) {
      let valueId = value.valueId || value.id;
      value = store.getState().values.find((v) => v.id == valueId);
    }
    if (!value?.progress_at?.length) {
      console.warn("removeProgress: no progress_at found for value", value?.id);
      return;
    }
    let progress_at = value.progress_at.filter((ts) => ts != timestamp);
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/${value.id}`, "PATCH", {
      value: { progress_at },
    });
    store.dispatch(setLoading(false));
    if (!!res.value) {
      store.dispatch(update(res.value));
      res.updated_values?.forEach((v) => store.dispatch(update(v)));
      return true;
    }
  },
  async createProgress(value, timestamp = null, note = null, prompt = true) {
    console.log("incoming", value);
    if (prompt) {
      // let confirm = await valueActions.confirm('confirm', 'set timestamp', 'Log progress for this item?')
      let confirm = await valueActions.confirm(
        "confirm",
        null,
        "Log progress for this item?",
      );
      if (!confirm) return;
      if (confirm == 2) {
        alert("prompt for datetime");
        return;
      }
    }

    // if(!!value.completed_at){
    //   alert('error: completed items cannot be progressed. please revise instead.')
    //   valueActions.maybePromptForRevision(value)
    //   return
    // }

    // let doneSinceMilestone = textHelpers.doneSinceMilestone(value)
    // if(doneSinceMilestone.length >= value.cycle || !!value.completed_at){
    //   valueActions.maybePromptForRevision(value)
    //   alert('error: max progress reached. please revise or complete.')
    //   return
    // }
    if (!!value.completed_at) {
      alert("error: cannot progress a completed item.");
      return;
    }

    if (!!timestamp) timestamp = new Date(timestamp);
    //.toUTCString()
    else timestamp = new Date(); //.toUTCString()

    let local = await storageActions.fetchItem("local", ENV.LOCAL);
    // if(!local){
    //   timestamp = timestamp.toUTCString()
    // }
    timestamp = timestamp.toISOString();

    if (timestamp == "Invalid Date") {
      alert(`Invalid date`);
      return;
    }

    let progress_at = value.progress_at || [];
    progress_at.unshift(timestamp);
    value.progress_at = progress_at;
    console.log(value);
    let data = {
      value: { progress_at },
      note,
    };

    let res = await apiActions.request(`values/${value.id}`, "PATCH", data);
    if (!res.value) return;
    value = { ...value, ...res.value };

    // console.log('updating values')
    // await valueActions.updateValues(value)
    // console.log('updated values')

    // await valueActions.removeToDo(value)

    // doneSinceMilestone = textHelpers.doneSinceMilestone(value)

    // if(doneSinceMilestone.length >= 7){
    //   // if(value.id == 2) return valueActions.complete(value, null, false)
    //   let res = await valueActions.promptForRevision()
    //   if(res == 'revise'){
    //     RootNavigation.push('Revise', {value, id: value.id})
    //   }
    //   else if(res == 'complete'){
    //     return valueActions.complete(value, null, false)
    //   }
    //   else {
    //     return value
    //   }
    // }
    // Vibration.vibrate(100);
    haptics.success();
    return value;
  },
  async maybePromptForRevision(value) {
    let doneSinceMilestone = textHelpers.doneSinceMilestone(value);
    if (
      value.cycle !== 0 &&
      doneSinceMilestone.length >= (value.cycle || ENV.CYCLE)
    ) {
      let frozen = await valueActions.checkIfFrozen(value);
      if (frozen) return;
      let res = await valueActions.promptForRevision();
      if (res == "revise") {
        RootNavigation.push("Revise", { value, id: value.id });
      } else if (res == "complete") {
        return valueActions.complete(value, null, false);
      }
    }
  },
  async snooze(value) {
    let days;
    if (ENV.WEB) {
      days = prompt("Snooze for how many days?");
    } else {
      days = Alert.alert("Snooze for how many days?", ``, [
        {
          text: 7,
          onPress: () => 7,
          // style: 'default'
        },
        { text: 2, onPress: () => 2 },
        { text: 1, onPress: () => 1 },
        {
          text: `cancel`,
          onPress: () => 0,
          style: "cancel",
        },
      ]);
    }

    if (!days) return;

    let snoozeUntil = new Date();
    snoozeUntil.setHours(24 * days, 0, 0, 0);
    // snoozeUntil = snoozeUntil.toUTCString()
    // let local = await storageActions.fetchItem('local', ENV.LOCAL)
    // if(!local){
    //   snoozeUntil = snoozeUntil.toUTCString()
    // }
    snoozeUntil = snoozeUntil.toISOString();

    // value.snooze_until = snoozeUntil
    store.dispatch(setLoading(true));
    let res = await apiActions.request(`values/${value.id}`, "PATCH", {
      value: { snooze_until: snoozeUntil },
    });
    console.log(res);
    store.dispatch(setLoading(false));
    if (!!res?.value) store.dispatch(update(res.value));
    return res.value;
  },
  async removeSnooze(id) {
    store.dispatch(setLoading(true));
    let { value } = await apiActions.request(`values/${id}`, "PATCH", {
      value: { snooze_until: null },
    });
    store.dispatch(setLoading(false));
    if (!!value) store.dispatch(update(value));
    return value;
  },
  async confirm(
    text,
    followUpText = "",
    title = "",
    subtitle = "",
    allowCancel = true,
  ) {
    return alertActions.confirm({
      options: [text, followUpText],
      title,
      subtitle,
      allowCancel,
    });
  },
  async promptForRevision() {
    return new Promise(async (resolve, reject) => {
      // let res = await valueActions.confirm('revise/extend', 'mark complete')
      // let res = await valueActions.confirm('revise/extend', 'mark complete')
      let res = await valueActions.confirm(
        "revise",
        "complete",
        "Progress bar filled!",
        `Would you like to revise this item to track it again, or mark it as complete?`,
      );
      if (res == 1) {
        resolve("revise");
      } else if (res == 2) {
        resolve("complete");
      } else {
        resolve(null);
      }
      // if(Platform.OS == 'web'){
      //   let revise = window.confirm('ready to revise/extend?')
      //   if(revise){
      //     resolve('revise')
      //   }
      //   else {
      //     let complete = window.confirm('do you want to complete this item?')
      //     if(complete){
      //       resolve('complete')
      //     }
      //   }
      // }
      // else {
      //   Alert.alert(`Ready to revise/extend, or mark complete?`, ``, [
      //     {text: `Revise`, onPress: () => {
      //       resolve('revise')
      //     }, style: 'default'},
      //     {text: `Complete`, onPress: () => {
      //       resolve('complete')
      //     }, style: 'default'},
      //   ])
      // }
    });
  },
  async checkIfFrozen(value, values = null) {
    if (!!value.archived_at) return false;
    if (!values) values = await storageActions.fetchItem("values", []);
    let frozen = false;
    // let ancestorIds = valueHelpers.ancestorIds(value, values)
    // let ancestors = values.filter(v => ancestorIds.includes(v.id))
    // ancestors.forEach(v => {
    //   if(!v.completed_at){
    //     let doneSinceMilestone = textHelpers.doneSinceMilestone(v)
    //     if(doneSinceMilestone.length >= ENV.CYCLE){
    //       frozen = true
    //     }
    //   }
    // })
    if (frozen) {
      alert("error: value is frozen by parents awaiting revision");
    }
    return frozen;
  },
  async toggleIsNote(value, prompt = false) {
    let confirm = null;
    // if (prompt) {
    //   let secondOption = shouldUncomplete ? null : "revise";
    //   confirm = await valueActions.confirm(
    //     `${shouldUncomplete ? "un" : ""}complete value`,
    //     secondOption,
    //     "Confirm"
    //   );
    //   if (!confirm) return;
    // }
    let wasNote = value.is_note;
    let data = {
      is_note: !wasNote,
      completed_at: null,
      completed: false,
    };
    return await valueActions.update(value.id, data);
  },
  async createIntroValues(values) {
    return await apiActions.request(`values/create_intro_values`, "POST", {
      values,
    });
  },
  async fetchMoments(id) {
    return await apiActions.request(`values/${id}/moments`);
  },
  async saveMomentHistory(id) {
    return await apiActions.request(`values/${id}/save_moment_history`, "POST");
  },
  // embedding-based suggestions for a piece of text (empty when the
  // embedding box is offline)
  async suggestForText(text, limit = 5, minScore = null) {
    let data = { text, limit };
    if (minScore != null) data.min_score = minScore;
    return await apiActions.request(`values/suggest_for_text`, "POST", data);
  },
};

export default valueActions;
